"use client"

import { useEffect, useRef, useState } from "react"
import useSWR from "swr"

const VersionSelector: React.FC = () => {
  const [selectedVersion, setSelectedVersion] = useState<string>()
  const currentVersionRef = useRef<string | undefined>(undefined)

  const versionsUrl =
    process.env.NODE_ENV === "production"
      ? "/versions.json"
      : "/versions.json"

  const { data } = useSWR(versionsUrl, async (url: string) => {
    const res = await fetch(url)
    if (!res.ok) {
      throw new Error(
        `Failed to fetch versions: ${res.status} ${res.statusText} ${await res.text()}`,
      )
    }
    return (await res.json()) as { versions: string[] }
  })

  useEffect(() => {
    const currentVersion = window.location.pathname
      .split("/")
      .find((p) => p.match(/^[\d.]+$/))
    setSelectedVersion(currentVersion)
    currentVersionRef.current = currentVersion
  }, [])

  if (!data) {
    return null
  }

  const handleChange = async (event: React.ChangeEvent<HTMLSelectElement>) => {
    currentVersionRef.current = event.target.value
    const newVersion = event.target.value

    const newPath = window.location.pathname.replace(
      `/${selectedVersion}`,
      `/${newVersion}`,
    )

    // Check if the page exists in the selected version
    const res = await fetch(newPath)
    if (res.status === 404) {
      // Page doesn't exist, redirect to the root of the selected version
      window.location.assign(`/${newVersion}`)
    } else {
      // Page exists, navigate to it
      window.location.assign(newPath)
    }
  }

  return (
    <select value={selectedVersion} onChange={handleChange}>
      {data.versions.map((version) => (
        <option key={version} value={version}>
          {version}
        </option>
      ))}
    </select>
  )
}

export default VersionSelector
